import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(query) {
    return await requestWrapper(null, 'GET', '/classifiers_classes', query);
  },
  async create(classEl) {
    return await requestWrapper(null, 'POST', '/classifiers_classes', null, classEl);
  },
  async getById(id) {
    return await requestWrapper(null, 'GET', `/classifiers_classes/single/${id}`);
  },
  async getByCode(obj) {
    const link = obj.code ? `${obj.table}/${obj.code}` : `${obj.table}`;
    return await requestWrapper(null, 'GET', `/classifiers_classes/code/${obj.classifier}/${link}`);
  },
  async getChilds(id) {
    return await requestWrapper(null, 'GET', `/classifiers_classes/childs/${id}`);
  },
  async update(classEl) {
    return await requestWrapper(null, 'PUT', `/classifiers_classes/${classEl.id}`, null, classEl);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/classifiers_classes/${id}`);
  },
};
